function convertUTCToCST(dateString) {
  // Ensure the input is a string and add 'Z' if missing

  if (!dateString) return null; // Handle null or undefined input

  if (typeof dateString !== 'string') {
    dateString = dateString.toISOString(); // If input is a Date, convert to ISO string
  }
  if (!dateString.endsWith('Z')) {
    dateString += 'Z'; // Append 'Z' to enforce UTC
  }

  // Parse the corrected UTC date
  const utcDate = new Date(dateString);

  // Format for CST/CDT with timezone-aware conversion
  const options = {
    timeZone: 'America/Chicago',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
    timeZoneName: 'short'
  };

  return utcDate.toLocaleString('en-US', options);
}

export default convertUTCToCST;
